import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Parser from 'html-react-parser';
import http from "../http";
import Obra from "./Obra";
import { Breadcrumb } from "./Breadcrumb";
import BtnBack from "./BtnBack";
import Nota from "./Nota";

const Sujeto = () => {
  
  const [isLoading, setIsLoading] = useState(true);
  const [sujeto, setSujeto] = useState({});
  const [categorias, setCategorias] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const [mpiosLeyenda] = useState([
    'chochola', 'dzidzantun', 'telchac-puerto'
  ])
  

  useEffect(() => {
    const getSujeto = async () => {
      setIsLoading(true);
      await http.get('/sujeto-obligado/'+id).
        then((resp) => {
          const data = resp.data;
          if(data === 'Error sujeto incorrecto' || data === 'Error sujeto no proporcionado'){
            navigate('/');
          }
          setIsLoading(false);
          setSujeto(data.sujeto);
          setCategorias(data.categorias);
        }
      )
    }
    getSujeto()
  },[]);

  return (
    <>
      { isLoading ? <p className="fs-4 mt-5">Espera....</p> :
      <div className="about_content-two mt-5 my-5">
        <Breadcrumb current={sujeto.nombre} />
        <h3 className="text-center">{sujeto.nombre}</h3>
        <div className="row">
          <div className="col-md-10">
            {
              (sujeto.id) !== 2 ? categorias.map((categoria,index) => (
                <div key={index}>
                  <p className="fs-18"><b>{categoria.nombre}</b></p>
                  {
                    categoria.num_obras > 0 
                    ? (<Obra obras={categoria.obras} sujeto={sujeto.id}/>) 
                    : (<p className="mx-4">Sin registro</p>)
                  }
                  
                </div>
              ))
              : <p className="fs-18">{Parser(categorias)}</p>
            }

            {mpiosLeyenda.includes(id) && <Nota mpio={id} />}


          </div>
          <div className="col-md-2">
            <div className="row">
              <div className="col-sm-12">
                <a href="https://iepac.mx/catalogo-de-politicas-publicas-2023.pdf" rel="noreferrer" target="_blank">
                  <img
                    src={require('../assets/descarga-catalogo-2023.png')} 
                    className="img-fluid mb-5"
                    alt="¿Cómo solicito un plebiscito?" />
                </a>
                
              </div>
              <div className="col-sm-12 mb-3">
                <Link to={process.env.PUBLIC_URL+"/como-solicito-un-plebiscito"}>
                  <img
                    src={require('../assets/como-solicito-un-plebiscito.png')} 
                    className="img-fluid"
                    alt="¿Cómo solicito un plebiscito?" />
                </Link>
              </div>
              
            </div>
          </div>
        </div>    
        
        <BtnBack />
      </div>
      }
    </>
    // </ObraProvider>
  )
}

export default Sujeto